// ナビゲーション関連
// document.addEventListener('DOMContentLoaded', function(){

	/**
	 * ドロワーメニュー初期設定
	 */
	let closeMenu = document.getElementById('close-btn');
	let openMenu = document.getElementById('open-menu');
	let bodySet = document.body;
	console.log(closeMenu);

	openMenu.getAttribute('aria-expanded', false);
	bodySet.classList.remove("is-open");
	openMenu.classList.remove("is-open");

	/**
	 * ドロワー開閉時画面固定
	 */
	let scrollpos;

	//クローズボタンでメニュー非表示
	function windowRecovery(){
		openMenu.setAttribute('aria-expanded', false);
		bodySet.classList.remove("is-open");
		openMenu.classList.remove("is-open");
		// bodySet.style.top = "0";
		window.scrollTo( 0 , scrollpos );
		closeMenu.classList.remove("is-open");
	}

	//オープンボタンでメニュー表示
	function windowFix(){
		if (openMenu.getAttribute("aria-expanded") == 'false') {
			openMenu.setAttribute('aria-expanded', true);
			scrollpos = document.documentElement.scrollTop || document.body.scrollTop;

			bodySet.style.top = `${scrollpos * -1}px`;
			bodySet.classList.add("is-open");
			openMenu.classList.add("is-open");
			closeMenu.classList.remove("is-open");
		} else {
			openMenu.setAttribute('aria-expanded', false);
			// closeMenu.classList.remove("is-open");
			bodySet.classList.remove("is-open");
			openMenu.classList.remove("is-open");
			// bodySet.style.top = "0";
			window.scrollTo( 0 , scrollpos );
		}
	}

	openMenu.addEventListener('click', windowFix,{passive: true});
	closeMenu.addEventListener('click', windowRecovery,{passive: true});

	// openMenuFoot.addEventListener('click', windowFix,{passive: true});


// });

// アンカーリンククリック時にメニューを閉じる

document.addEventListener("DOMContentLoaded", function(){
	setTimeout(function(){
		const anchorLinksArr = document.querySelectorAll(".list-menu .item a");
		// console.log(anchorLinksArr);
		anchorLinksArr.forEach((trigger) => {
			trigger.addEventListener("click", () => {
				// document.getElementById('drawer').checked = false;
				openMenu.setAttribute('aria-expanded', false);
				bodySet.classList.remove("is-open");
				openMenu.classList.remove("is-open");
				// bodySet.style.top = "0";
				window.scrollTo( 0 , scrollpos );
				closeMenu.classList.remove("is-open");
			});
		});
	}, 80);
});